export function NavBar1() {
  return (
    <svg
      width="130"
      height="57"
      viewBox="0 0 130 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" fill="white" />
      <rect x="22.5" y="20" width="17" height="17" rx="3.5" fill="#FBFBFA" />
      <path
        d="M25.5575 32.5517L28.4333 30.6209C28.8942 30.3117 29.5592 30.3467 29.9733 30.7026L30.1658 30.8717C30.6208 31.2626 31.3558 31.2626 31.8108 30.8717L34.2375 28.7892C34.6925 28.3984 35.4275 28.3984 35.8825 28.7892L36.8333 29.6059"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.25 34.3307H32.75C35.6667 34.3307 36.8334 33.1641 36.8334 30.2474V26.7474C36.8334 23.8307 35.6667 22.6641 32.75 22.6641H29.25C26.3334 22.6641 25.1667 23.8307 25.1667 26.7474V30.2474C25.1667 33.1641 26.3334 34.3307 29.25 34.3307Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.25 27.3294C29.8944 27.3294 30.4167 26.8071 30.4167 26.1628C30.4167 25.5184 29.8944 24.9961 29.25 24.9961C28.6057 24.9961 28.0834 25.5184 28.0834 26.1628C28.0834 26.8071 28.6057 27.3294 29.25 27.3294Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.75 32.5807L26.0417 33.1641L27.2083 33.7474H28.6667H33.625L35.0833 33.4557L36.25 32.5807L36.5417 29.9557L36.25 29.6641L35.9583 29.3724L35.375 28.7891H34.7917L34.5 29.0807L32.4583 30.8307L31.5833 31.4141H30.7083L28.9583 30.5391L25.75 32.5807Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.583333"
      />
      <rect x="22.5" y="20" width="17" height="17" rx="3.5" stroke="#EED9BA" />
      <path d="M60.5 28.5H77.5" stroke="#DDDCDC" strokeWidth="4" />
      <rect x="93" y="23.5" width="20" height="10" fill="#D4A655" />
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}

export function NavBar2() {
  return (
    <svg
      width="130"
      height="57"
      viewBox="0 0 130 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" fill="white" />
      <rect x="17" y="23.5" width="20" height="10" fill="#D4A655" />
      <path d="M52.5 28.5H69.5" stroke="#DDDCDC" strokeWidth="4" />
      <rect x="90.5" y="20" width="17" height="17" rx="3.5" fill="#FBFBFA" />
      <path
        d="M93.5575 32.5517L96.4333 30.6209C96.8942 30.3117 97.5592 30.3467 97.9733 30.7026L98.1658 30.8717C98.6208 31.2626 99.3558 31.2626 99.8108 30.8717L102.237 28.7892C102.692 28.3984 103.427 28.3984 103.882 28.7892L104.833 29.6059"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.25 34.3307H100.75C103.667 34.3307 104.833 33.1641 104.833 30.2474V26.7474C104.833 23.8307 103.667 22.6641 100.75 22.6641H97.25C94.3334 22.6641 93.1667 23.8307 93.1667 26.7474V30.2474C93.1667 33.1641 94.3334 34.3307 97.25 34.3307Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.25 27.3294C97.8943 27.3294 98.4167 26.8071 98.4167 26.1628C98.4167 25.5184 97.8943 24.9961 97.25 24.9961C96.6057 24.9961 96.0833 25.5184 96.0833 26.1628C96.0833 26.8071 96.6057 27.3294 97.25 27.3294Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.75 32.5807L94.0417 33.1641L95.2084 33.7474H96.6667H101.625L103.083 33.4557L104.25 32.5807L104.542 29.9557L104.25 29.6641L103.958 29.3724L103.375 28.7891H102.792L102.5 29.0807L100.458 30.8307L99.5834 31.4141H98.7084L96.9584 30.5391L93.75 32.5807Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.583333"
      />
      <rect x="90.5" y="20" width="17" height="17" rx="3.5" stroke="#EED9BA" />
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}
export function NavBar3() {
  return (
    <svg
      width="130"
      height="57"
      viewBox="0 0 130 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" fill="white" />
      <rect x="13.5" y="23.5" width="20" height="10" fill="#D4A655" />
      <rect x="59.5" y="20" width="17" height="17" rx="3.5" fill="#FBFBFA" />
      <path
        d="M62.5575 32.5517L65.4333 30.6209C65.8942 30.3117 66.5592 30.3467 66.9733 30.7026L67.1658 30.8717C67.6208 31.2626 68.3558 31.2626 68.8108 30.8717L71.2375 28.7892C71.6925 28.3984 72.4275 28.3984 72.8825 28.7892L73.8333 29.6059"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.25 34.3307H69.75C72.6667 34.3307 73.8334 33.1641 73.8334 30.2474V26.7474C73.8334 23.8307 72.6667 22.6641 69.75 22.6641H66.25C63.3334 22.6641 62.1667 23.8307 62.1667 26.7474V30.2474C62.1667 33.1641 63.3334 34.3307 66.25 34.3307Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.25 27.3294C66.8943 27.3294 67.4167 26.8071 67.4167 26.1628C67.4167 25.5184 66.8943 24.9961 66.25 24.9961C65.6057 24.9961 65.0833 25.5184 65.0833 26.1628C65.0833 26.8071 65.6057 27.3294 66.25 27.3294Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M62.75 32.5807L63.0417 33.1641L64.2083 33.7474H65.6667H70.625L72.0833 33.4557L73.25 32.5807L73.5417 29.9557L73.25 29.6641L72.9583 29.3724L72.375 28.7891H71.7917L71.5 29.0807L69.4583 30.8307L68.5833 31.4141H67.7083L65.9583 30.5391L62.75 32.5807Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.583333"
      />
      <rect x="59.5" y="20" width="17" height="17" rx="3.5" stroke="#EED9BA" />
      <path d="M101 28.5H118" stroke="#DDDCDC" strokeWidth="4" />
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}

export function NavBar4() {
  return (
    <svg
      width="130"
      height="57"
      viewBox="0 0 130 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" fill="white" />
      <path d="M12 28.5H29" stroke="#DDDCDC" strokeWidth="4" />
      <rect x="53.5" y="20" width="17" height="17" rx="3.5" fill="#FBFBFA" />
      <path
        d="M56.5575 32.5517L59.4333 30.6209C59.8942 30.3117 60.5592 30.3467 60.9733 30.7026L61.1658 30.8717C61.6208 31.2626 62.3558 31.2626 62.8108 30.8717L65.2375 28.7892C65.6925 28.3984 66.4275 28.3984 66.8825 28.7892L67.8333 29.6059"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.25 34.3307H63.75C66.6667 34.3307 67.8334 33.1641 67.8334 30.2474V26.7474C67.8334 23.8307 66.6667 22.6641 63.75 22.6641H60.25C57.3334 22.6641 56.1667 23.8307 56.1667 26.7474V30.2474C56.1667 33.1641 57.3334 34.3307 60.25 34.3307Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.25 27.3294C60.8943 27.3294 61.4167 26.8071 61.4167 26.1628C61.4167 25.5184 60.8943 24.9961 60.25 24.9961C59.6057 24.9961 59.0833 25.5184 59.0833 26.1628C59.0833 26.8071 59.6057 27.3294 60.25 27.3294Z"
        stroke="#D4A655"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.75 32.5807L57.0417 33.1641L58.2084 33.7474H59.6667H64.625L66.0834 33.4557L67.25 32.5807L67.5417 29.9557L67.25 29.6641L66.9584 29.3724L66.375 28.7891H65.7917L65.5 29.0807L63.4584 30.8307L62.5834 31.4141H61.7084L59.9584 30.5391L56.75 32.5807Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.583333"
      />
      <rect x="53.5" y="20" width="17" height="17" rx="3.5" stroke="#EED9BA" />
      <rect x="96.5" y="23.5" width="20" height="10" fill="#D4A655" />
      <rect x="0.5" y="0.5" width="129" height="56" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}
export function Main1() {
  return (
    <svg
      width="302"
      height="90"
      viewBox="0 0 302 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="301" height="89" rx="1.5" fill="white" />
      <rect
        x="56.95"
        y="18.582"
        width="188.1"
        height="52.8359"
        fill="#FBFBFA"
      />
      <path
        d="M143.224 41.8726L147.333 39.1139C147.991 38.6722 148.941 38.7222 149.533 39.2306L149.808 39.4723C150.458 40.0307 151.508 40.0307 152.158 39.4723L155.626 36.4969C156.276 35.9385 157.326 35.9385 157.976 36.4969L159.334 37.6637"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M148.5 44.4149H153.5C157.668 44.4149 159.334 42.748 159.334 38.5808V33.5802C159.334 29.413 157.668 27.7461 153.5 27.7461H148.5C144.332 27.7461 142.666 29.413 142.666 33.5802V38.5808C142.666 42.748 144.332 44.4149 148.5 44.4149Z"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M148.5 34.4119C149.42 34.4119 150.167 33.6656 150.167 32.745C150.167 31.8244 149.42 31.0781 148.5 31.0781C147.579 31.0781 146.833 31.8244 146.833 32.745C146.833 33.6656 147.579 34.4119 148.5 34.4119Z"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.499 41.9135L143.916 42.7469L145.583 43.5803H147.666H154.75L156.834 43.1636L158.501 41.9135L158.918 38.163L158.501 37.7463L158.084 37.3295L157.251 36.4961H156.417L156.001 36.9128L153.084 39.4131L151.833 40.2466H150.583L148.083 38.9964L143.499 41.9135Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.833442"
      />
      <rect
        x="131.45"
        y="50.0859"
        width="39.1"
        height="5.83333"
        fill="#FAF4EB"
      />
      <path d="M137 59.918H165" stroke="#DDDCDC" />
      <path d="M137 63.918H165" stroke="#DDDCDC" />
      <rect
        x="56.95"
        y="18.582"
        width="188.1"
        height="52.8359"
        stroke="#EED9BA"
      />
      <rect x="0.5" y="0.5" width="301" height="89" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}
export function Main2() {
  return (
    <svg
      width="302"
      height="90"
      viewBox="0 0 302 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="301" height="89" rx="1.5" fill="white" />
      <rect x="22.5" y="27.5" width="169.003" height="35.0026" fill="#FBFBFA" />
      <path
        d="M99.2253 50.7906L103.334 48.0319C103.993 47.5902 104.943 47.6402 105.534 48.1486L105.809 48.3903C106.46 48.9487 107.51 48.9487 108.16 48.3903L111.627 45.4149C112.277 44.8565 113.327 44.8565 113.977 45.4149L115.336 46.5817"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.501 53.3329H109.502C113.669 53.3329 115.336 51.666 115.336 47.4988V42.4982C115.336 38.3309 113.669 36.6641 109.502 36.6641H104.501C100.334 36.6641 98.6669 38.3309 98.6669 42.4982V47.4988C98.6669 51.666 100.334 53.3329 104.501 53.3329Z"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.501 43.3299C105.422 43.3299 106.168 42.5836 106.168 41.663C106.168 40.7424 105.422 39.9961 104.501 39.9961C103.58 39.9961 102.834 40.7424 102.834 41.663C102.834 42.5836 103.58 43.3299 104.501 43.3299Z"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.5003 50.8314L99.9171 51.6649L101.584 52.4983H103.668H110.752L112.835 52.0816L114.502 50.8314L114.919 47.0809L114.502 46.6642L114.086 46.2475L113.252 45.4141H112.419L112.002 45.8308L109.085 48.3311L107.835 49.1646H106.585L104.084 47.9144L99.5003 50.8314Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.833442"
      />
      <rect
        x="22.5"
        y="27.5"
        width="169.003"
        height="35.0026"
        stroke="#EED9BA"
      />
      <rect x="202.003" y="32" width="77.9974" height="10" fill="#FAF4EB" />
      <path d="M202.003 46H280" stroke="#DDDCDC" />
      <path d="M202.003 50H280" stroke="#DDDCDC" />
      <path d="M202.003 54H280" stroke="#DDDCDC" />
      <rect x="0.5" y="0.5" width="301" height="89" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}
export function Main3() {
  return (
    <svg
      width="302"
      height="96"
      viewBox="0 0 302 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="3.5" width="301" height="89" rx="1.5" fill="white" />
      <rect x="95" y="12" width="112" height="10" fill="#FAF4EB" />
      <path d="M109 26H193" stroke="#DDDCDC" />
      <path d="M109 30H193" stroke="#DDDCDC" />
      <path d="M109 34H193" stroke="#DDDCDC" />
      <rect
        x="66.4987"
        y="48.5"
        width="169.003"
        height="35.0026"
        fill="#FBFBFA"
      />
      <path
        d="M143.224 71.7906L147.333 69.0319C147.991 68.5902 148.941 68.6402 149.533 69.1486L149.808 69.3903C150.458 69.9487 151.508 69.9487 152.158 69.3903L155.626 66.4149C156.276 65.8565 157.326 65.8565 157.976 66.4149L159.334 67.5817"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M148.5 74.3329H153.5C157.668 74.3329 159.334 72.666 159.334 68.4988V63.4982C159.334 59.3309 157.668 57.6641 153.5 57.6641H148.5C144.332 57.6641 142.666 59.3309 142.666 63.4982V68.4988C142.666 72.666 144.332 74.3329 148.5 74.3329Z"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M148.5 64.3299C149.42 64.3299 150.167 63.5836 150.167 62.663C150.167 61.7424 149.42 60.9961 148.5 60.9961C147.579 60.9961 146.833 61.7424 146.833 62.663C146.833 63.5836 147.579 64.3299 148.5 64.3299Z"
        stroke="#D4A655"
        strokeWidth="1.25016"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M143.499 71.8314L143.916 72.6649L145.583 73.4983H147.666H154.75L156.834 73.0816L158.501 71.8314L158.918 68.0809L158.501 67.6642L158.084 67.2475L157.251 66.4141H156.417L156.001 66.8308L153.084 69.3311L151.833 70.1646H150.583L148.083 68.9144L143.499 71.8314Z"
        fill="#D4A655"
        stroke="#D4A655"
        strokeWidth="0.833442"
      />
      <rect
        x="66.4987"
        y="48.5"
        width="169.003"
        height="35.0026"
        stroke="#EED9BA"
      />
      <rect x="0.5" y="3.5" width="301" height="89" rx="1.5" stroke="#FAF4EB" />
    </svg>
  );
}
export function HotelIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_17327_47598)">
       
        <g mask="url(#mask0_17327_47598)">
          <path
            d="M4.96875 23.2979H20.0313V4.46971H4.96875V23.2979Z"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.0313 2.21035C20.0313 1.81084 19.8727 1.42787 19.59 1.14545C19.3075 0.862648 18.9246 0.704117 18.525 0.704117H6.47503C6.07547 0.704117 5.6925 0.862648 5.41008 1.14545C5.12733 1.42787 4.96875 1.81084 4.96875 2.21035V4.46973H20.0313V2.21035Z"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9941 23.2979H14.0067V18.7791H10.9941V23.2979Z"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.98145 7.48128V8.23438"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9937 7.48128V8.23438"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.0068 7.48128V8.23438"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.0186 7.48128V8.23438"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.98145 11.2478V12.001"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9937 11.2478V12.001"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.0068 11.2478V12.001"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.0186 11.2478V12.001"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.98145 15.0135V15.7666"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.9937 15.0135V15.7666"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.0068 15.0135V15.7666"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.0186 15.0135V15.7666"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.98145 18.7782V19.5312"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.0186 18.7782V19.5312"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.20312 23.2979H23.7969"
            stroke=""
            strokeWidth="1.25"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_17327_47598">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
//#1E85FF
export function FlightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
     
      <g mask="url(#mask0_17327_47641)">
        <path
          d="M22.5941 1.90636C21.5782 0.890406 18.6955 2.12581 16.1556 4.66576L12.5525 8.26881C8.82895 11.9924 6.03096 15.4056 2.97021 19.6907L4.80979 21.5303C9.09488 18.4695 12.5081 15.6715 16.2317 11.948L19.8347 8.34495C22.3746 5.80499 23.6101 2.92232 22.5941 1.90636Z"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.93018 19.9715L9.40891 22.4502L10.3287 21.5304L9.48973 18.1908"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.46069 15.0487L2.97008 14.1717L2.05029 15.0916L4.52903 17.5703"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9434 7.89275L3.7381 2.36662L2.3584 3.74632L9.74391 11.1318"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3691 14.7561L20.7546 22.1416L22.1343 20.7619L16.6082 11.5566"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6354 6.50684L12.4764 4.66588L10.6368 2.82631L8.33643 5.1267"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3738 16.1641L21.6742 13.8637L19.8346 12.0241L17.9937 13.8651"
          stroke=""
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
export function TransportationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M17.1875 4.8125H4.8125C4.05311 4.8125 3.4375 5.42811 3.4375 6.1875V11.6875C3.4375 12.4469 4.05311 13.0625 4.8125 13.0625H17.1875C17.9469 13.0625 18.5625 12.4469 18.5625 11.6875V6.1875C18.5625 5.42811 17.9469 4.8125 17.1875 4.8125Z"
        stroke=""
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1875 13.0625H4.8125C4.05311 13.0625 3.4375 13.6781 3.4375 14.4375V17.1875C3.4375 17.9469 4.05311 18.5625 4.8125 18.5625H17.1875C17.9469 18.5625 18.5625 17.9469 18.5625 17.1875V14.4375C18.5625 13.6781 17.9469 13.0625 17.1875 13.0625Z"
        stroke=""
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1875 4.8125H4.8125C4.44814 4.81148 4.099 4.66629 3.84136 4.40864C3.58371 4.151 3.43852 3.80186 3.4375 3.4375C3.43852 3.07314 3.58371 2.724 3.84136 2.46636C4.099 2.20871 4.44814 2.06352 4.8125 2.0625H17.1875C17.5519 2.06352 17.901 2.20871 18.1586 2.46636C18.4163 2.724 18.5615 3.07314 18.5625 3.4375C18.5615 3.80186 18.4163 4.151 18.1586 4.40864C17.901 4.66629 17.5519 4.81148 17.1875 4.8125ZM6.1875 18.5625V19.5078C6.1875 19.6218 6.14223 19.7311 6.06165 19.8116C5.98107 19.8922 5.87177 19.9375 5.75781 19.9375H4.55469C4.44073 19.9375 4.33143 19.8922 4.25085 19.8116C4.17027 19.7311 4.125 19.6218 4.125 19.5078V18.5625H6.1875ZM17.875 18.5625V19.5078C17.875 19.6218 17.8297 19.7311 17.7491 19.8116C17.6686 19.8922 17.5593 19.9375 17.4453 19.9375H16.2422C16.1282 19.9375 16.0189 19.8922 15.9384 19.8116C15.8578 19.7311 15.8125 19.6218 15.8125 19.5078V18.5625H17.875Z"
        stroke=""
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8125 16.5C16.1922 16.5 16.5 16.1922 16.5 15.8125C16.5 15.4328 16.1922 15.125 15.8125 15.125C15.4328 15.125 15.125 15.4328 15.125 15.8125C15.125 16.1922 15.4328 16.5 15.8125 16.5Z"
        stroke=""
        strokeLinejoin="round"
      />
      <path
        d="M6.1875 16.5C6.5672 16.5 6.875 16.1922 6.875 15.8125C6.875 15.4328 6.5672 15.125 6.1875 15.125C5.8078 15.125 5.5 15.4328 5.5 15.8125C5.5 16.1922 5.8078 16.5 6.1875 16.5Z"
        stroke=""
        strokeLinejoin="round"
      />
      <path
        d="M11 4.8125V13.0625M3.4375 3.4375V15.8125M18.5625 3.4375V15.8125"
        stroke=""
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TourIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.4389 14.4352H13.1905H12.4429H11.7496L11.9685 13.7773C12.8664 11.0794 13.3031 8.99587 13.3031 7.55266C13.3031 5.66396 12.9645 3.9035 12.3706 2.59387L13.4389 14.4352ZM13.4389 14.4352L13.5889 14.2373M13.4389 14.4352L13.5889 14.2373M13.5889 14.2373C14.44 13.1146 15.2629 11.9094 15.8754 10.7667C16.4791 9.64041 16.915 8.50897 16.915 7.55266C16.915 4.67795 15.139 2.21324 12.6297 1.19318L11.2243 0.621839M13.5889 14.2373L11.2243 0.621839M11.2243 0.621839L12.0146 1.91684M11.2243 0.621839L12.0146 1.91684M12.0146 1.91684C12.1391 2.12086 12.2582 2.34625 12.3706 2.59373L12.0146 1.91684ZM8.62258 17.2896V17.1014L8.49849 16.9599C7.90965 16.2885 7.20618 15.4523 6.49855 14.5329C5.31551 12.9956 4.43544 11.6348 3.85298 10.4568C3.26764 9.27308 3 8.30803 3 7.55266C3 3.66419 6.16419 0.5 10.0526 0.5C13.9411 0.5 17.1055 3.66421 17.1055 7.55266C17.1055 8.30803 16.8378 9.27307 16.2525 10.4568C15.67 11.6348 14.7899 12.9956 13.6069 14.5329C12.8993 15.4524 12.1958 16.2885 11.607 16.9599L11.4829 17.1014V17.2896V19.4048C11.4829 19.4573 11.4403 19.5 11.3876 19.5H8.71781C8.66521 19.5 8.62258 19.4574 8.62258 19.4048V17.2896ZM10.7924 19.3095H11.2924V18.8095V17.6593V17.1593H10.7924H9.31309H8.81309V17.6593V18.8095V19.3095H9.31309H10.7924ZM11.1229 16.9688H11.3501L11.4995 16.7977C11.8884 16.3523 12.2695 15.9001 12.6427 15.4414L13.3062 14.6259L12.2548 14.6259L8.50401 14.6261C8.49988 14.6259 8.49505 14.6259 8.48969 14.6259H7.85066H6.79567L7.46366 15.4424C7.83857 15.9008 8.22116 16.3528 8.61127 16.7982L8.76066 16.9688H8.98742H11.1229ZM12.197 2.67236L12.197 2.67235C11.938 2.10128 11.6321 1.62244 11.2882 1.2787C10.9475 0.938056 10.5272 0.690508 10.0527 0.690508C9.57815 0.690508 9.15791 0.938076 8.81718 1.2787C8.47334 1.62244 8.16741 2.10128 7.90843 2.67236C7.30981 3.99237 6.99266 5.72683 6.99266 7.55266C6.99266 9.08439 7.50842 11.3504 8.44571 14.0967L8.56123 14.4352H8.91891H11.1867H11.5444L11.6599 14.0967C12.5969 11.3507 13.1126 9.08394 13.1126 7.55266C13.1126 5.7269 12.7956 3.9924 12.197 2.67236ZM7.47572 1.19314C5.02719 2.18855 3.27693 4.5595 3.19362 7.34457L3.19047 7.34777V7.55266C3.19047 8.37308 3.50942 9.35996 4.06417 10.4591C4.62414 11.5686 5.44824 12.8386 6.51329 14.238L6.66336 14.4352H6.91117H7.66234H8.35572L8.13676 13.7773C7.23889 11.0796 6.80234 8.99631 6.80234 7.55266C6.80234 5.66394 7.14098 3.90337 7.73486 2.59372L7.73487 2.5937C7.847 2.3464 7.96622 2.12099 8.09084 1.91677L8.88101 0.621844L7.47572 1.19314Z"
        fill="#050001"
        stroke=""
      />
    </svg>
  );
}
export function VisaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_17327_47670)">
        <path
          d="M14.6772 19.5H3.16016V2.92122H14.6772C15.8718 2.92122 16.8402 3.89081 16.8402 5.08683V17.3344C16.8402 18.5304 15.8718 19.5 14.6772 19.5Z"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.16016 2.92188L12.182 0.582271C13.6136 0.159777 15.0513 1.44263 14.8683 2.92188"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3986 10.3223C14.3986 12.7547 12.4292 14.7266 9.99982 14.7266C7.57044 14.7266 5.60107 12.7547 5.60107 10.3223C5.60107 7.88998 7.57044 5.91816 9.99982 5.91816C12.4292 5.91816 14.3986 7.88998 14.3986 10.3223Z"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.62525 5.95385C7.9925 9.20683 7.97978 11.4503 9.59891 14.6904"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3929 14.6904C12.0136 11.4449 12.0141 9.20147 10.3828 5.95385"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.73193 10.3232H14.2608"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.76318 17.1309H7.80527"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.1714 17.1309H14.399"
          stroke=""
          strokeWidth="1.04167"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_17327_47670">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
